import { render, staticRenderFns } from "./grade-info.vue?vue&type=template&id=12df4380&scoped=true&lang=pug"
import script from "./grade-info.vue?vue&type=script&lang=js"
export * from "./grade-info.vue?vue&type=script&lang=js"
import style0 from "./grade-info.vue?vue&type=style&index=0&id=12df4380&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12df4380",
  null
  
)

export default component.exports